import React, { Component } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function TermsOfServicePage() {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-[#FFF5EB]" data-id="element-492">
      {/* Header with back button */}
      <div className="bg-white shadow-sm sticky top-0 z-10" data-id="element-493">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-494">
          <button onClick={() => navigate('/')} className="inline-flex items-center text-[#E87B5C] hover:text-[#E87B5C]/80 transition-colors" data-id="element-495">
            <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-496" />
            Back to Home
          </button>
        </div>
      </div>

      {/* Terms of Service Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-497">
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-498">
          <h1 className="text-4xl font-bold text-[#E87B5C] mb-8" data-id="element-499">
            Terms of Use
          </h1>

          <div className="space-y-8 text-gray-700" data-id="element-500">
            <div data-id="element-501">
              <p className="leading-relaxed mb-4" data-id="element-502">
                Please read the following carefully before installing and/or
                using the software. By clicking "I agree" or "accept" (or other
                similar button), or by otherwise accessing and/or using any part
                of the service (defined below), you acknowledge that you have
                read, understood, and agreed to be bound by all the terms and
                conditions of this end user license agreement (the "Agreement"),
                the date of such occurrence being the "Effective date".
              </p>
              <p className="leading-relaxed mb-4" data-id="element-503">
                This agreement constitutes a binding agreement between you and
                Emigo Wellness, Inc. ("Emigo", "We", "us" or "our"), and governs
                your access and use of the software and services, as well as any
                future software or services.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-504">
                If you are entering into this agreement on behalf of an entity,
                you represent that you have the right, authority, and capacity
                to bind such entity to this agreement and in such case all
                references to "you" hereinafter shall mean such entity.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-505">
                If you do not agree with any of the terms and conditions of this
                agreement, please do not download, install or use the service.
                By accessing, installing, downloading or using our website,
                services and/or software, you confirm that you are at least 16
                years old (or if you are younger than 16 years old that you are
                accessing, installing, downloading or using our website,
                services and/or software only with the approval of your parent
                or guardian and, that you are legally able to enter into this
                agreement, and that you have read, understand and agree to be
                bound by this agreement.
              </p>
              <p className="leading-relaxed" data-id="element-506">
                Notwithstanding anything to the contrary, to the extent that
                consumer protection or local laws or regulations grant you
                mandatory or statutory rights, this agreement shall only limit
                such rights to the maximum extent permitted by such laws or
                regulations.
              </p>
            </div>

            <div data-id="element-507">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-508">
                1. Definitions
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-509">
                The following capitalized terms have the meanings set forth
                below:
              </p>
              <p className="leading-relaxed mb-3" data-id="element-510">
                <strong data-id="element-511">1.1 "Intellectual Property Rights"</strong> means any
                and all rights, titles, and interests (under any jurisdiction or
                treaty, whether protectable or not, whether registered or
                unregistered, and whether vested, contingent, or future) in and
                to inventions, discoveries, works of authorship, designs,
                software, technical information, databases, know-how, mask
                works, methods, technology, and other intellectual property, and
                includes but is not limited to patents, copyrights and similar
                authorship rights, moral (and similar personal) rights, mask
                work rights, data and database rights, trade secret rights and
                similar rights in confidential information and other non-public
                information, design rights, trademark, service mark, trade name,
                trade dress and similar branding rights, as well as: (i) all
                applications, registrations, renewals, reexaminations,
                extensions, continuations, continuations-in-part, provisionals,
                substitutions, divisions or reissues of or for the foregoing;
                and (ii) all goodwill associated with the foregoing.
              </p>
              <p className="leading-relaxed mb-3" data-id="element-512">
                <strong data-id="element-513">1.2 "Law"</strong> means any federal, state, province,
                foreign, regional or local statute, regulation, ordinance, or
                rule of any jurisdiction.
              </p>
              <p className="leading-relaxed mb-3" data-id="element-514">
                <strong data-id="element-515">1.3 "License Scope"</strong> means any Service usage
                and/or consumption limitations and parameters (for example, as
                to volume of users, location, features, duration, etc.) set
                forth in the Software registration page.
              </p>
              <p className="leading-relaxed mb-3" data-id="element-516">
                <strong data-id="element-517">1.4 "Service"</strong> means the services provided by
                the Software including, without limitation, a writing assistant
                Software and the document summarization Software ("Summarization
                Service").
              </p>
              <p className="leading-relaxed" data-id="element-518">
                <strong data-id="element-519">1.5 "Software"</strong> means Emigo's iOS keyboard
                application, available exclusively from the Apple App Store and
                known as Emigo, including all of its features, user interfaces,
                dashboards, data analytics and functionality, together with its
                integrated interaction with any large language model (LLM) or
                related AI systems that enable its core features.
              </p>
            </div>

            <div data-id="element-520">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-521">
                2. License
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-522">
                <strong data-id="element-523">2.1 General.</strong> Subject to the terms and
                conditions of this Agreement, during the Term (defined below),
                Emigo grants you a personal, limited, revocable, non-exclusive,
                non-sublicensable, non-assignable, non-transferable license
                ("License"), to: (i) download, install and use the Software on
                your smartphone ("Device") that you own or control; and (ii)
                access and use the Software on that Device in accordance with
                this Agreement and any applicable Usage Rules (defined below);
                solely for your own personal purposes.
              </p>
              <p className="leading-relaxed mb-3" data-id="element-524">
                <strong data-id="element-525">2.2 Restrictions.</strong> You agree not to, and shall
                not permit any third party to: (i) sublicense, redistribute,
                sell, lease, lend or rent the Software; (ii) make the Software
                available over a network where it could be used by multiple
                devices owned or operated by different people at the same time;
                (iii) disassemble, reverse engineer, decompile, decrypt, or
                attempt to derive the source code of, the Software; (iv) copy
                (except for back-up purposes), modify, improve, or create
                derivative works of the Software or any part thereof; (v)
                circumvent, disable or otherwise interfere with security-related
                features of the Software or features that prevent or restrict
                use or copying of any content or that enforce limitations on use
                of the Software; (vi) remove, alter or obscure any proprietary
                notice or identification, including copyright, trademark, patent
                or other notices, contained in or displayed on or via the
                Software; (vii) use any communications systems provided by the
                Software to send unauthorized and/or unsolicited commercial
                communications; (viii) use the Emigo name, logo or trademarks
                without our prior written consent; and/or (ix) use the Software
                to violate any applicable laws, rules or regulations, or for any
                unlawful, harmful, irresponsible, or inappropriate purpose, or
                in any manner that breaches this Agreement.
              </p>
              <p className="leading-relaxed mb-3" data-id="element-526">
                <strong data-id="element-527">2.3 Additional software.</strong> Emigo may offer you
                additional software, including certain interfaces, for download
                ("Additional software"). Subject to the other terms and
                conditions of this Agreement, you may install and use Additional
                software on Devices controlled by you, solely in conjunction
                with your authorized use of the Services. Upon expiration or
                termination of this Agreement for any reason, you shall cease
                any further use of the Additional software and shall promptly
                destroy all copies thereof in your possession. Certain Services
                or Software (including Additional software) may be subject to
                additional limitations, restrictions, terms and/or conditions
                specific to such Services or Software ("Specific Terms"). In
                such cases, the applicable Specific Terms will be made available
                to you and your access to and use of the relevant Services or
                Software will be contingent upon your acceptance of and
                compliance with such Specific Terms.
              </p>
              <p className="leading-relaxed" data-id="element-528">
                <strong data-id="element-529">2.4 Hosting.</strong> The Service will be hosted by one
                or more third party hosting services providers or systems
                selected by Emigo at its discretion and from time to time
                ("Hosting Provider"). The availability of the Service will be
                subject to the terms and uptime commitments offered by each such
                Hosting Provider.
              </p>
            </div>

            <div data-id="element-530">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-531">
                3. Account
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-532">
                In order to access the Service, you may be required to set up an
                account by submitting the information requested in the
                applicable form or interface ("Account"). You represent and
                warrant that all information submitted during the set up process
                is, and will thereafter remain, complete and accurate.
              </p>
              <p className="leading-relaxed" data-id="element-533">
                As between Emigo and you, you alone shall be responsible and
                liable for maintaining the confidentiality and security of the
                Account credentials, as well as for all activities that occur
                under or in such Account.
              </p>
            </div>

            <div data-id="element-534">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-535">
                4. Usage Rules
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-536">
                In order to have access to the Software you must download it
                from Apple App Store ("Distributor"), please be aware that the
                Distributor may have established usage rules which also govern
                your use of the Software ("Usage Rules"). You acknowledge that,
                prior to downloading the Software from a Distributor, you have
                had the opportunity to review and understand, and will comply
                with, its Usage Rules.
              </p>
              <p className="leading-relaxed" data-id="element-537">
                The Usage Rules that are applicable to your use of the Software
                are incorporated into this Agreement by this reference. You
                represent that you are not prohibited by any applicable Usage
                Rules and/or applicable law from using the Software; if you are
                unable to make such a representation you are prohibited from
                installing and/or using the Software.
              </p>
            </div>

            <div data-id="element-538">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-539">
                5. Intellectual Property Rights
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-540">
                <strong data-id="element-541">5.1 Ownership.</strong> The Software is licensed as
                explained above and not sold to you under this Agreement and you
                acknowledge that Emigo and its licensors retain all title,
                ownership rights and Intellectual Property Rights in and to the
                Software. We reserve all rights not expressly granted herein to
                the Software.
              </p>
              <p className="leading-relaxed mb-3" data-id="element-542">
                <strong data-id="element-543">5.2 Emigo Content.</strong> Except for the User Content
                (as defined in clause 5.3 below) the: (i) content on the
                Software, including, without limitation, the text, information,
                documents, descriptions, products, software, graphics, photos,
                sounds, videos, interactive features, and services (the
                "Materials"), (ii) the trademarks, service marks and logos
                contained therein ("Marks", and together with the Materials, the
                "Emigo Content"), are the property of Emigo and/or its licensors
                and may be protected by applicable copyright or other
                intellectual property laws and treaties. "Emigo", and the Emigo
                logo are Marks of Emigo and its affiliates.
              </p>
              <p className="leading-relaxed mb-3" data-id="element-544">
                <strong data-id="element-545">5.3 User Content and Use Derived Content.</strong> You
                are solely responsible for all interactions, text, documents or
                other content or information uploaded, entered or otherwise
                transmitted by you in connection with your use of the Services
                and/or Software ("User Content") and the User Derived Content
                (as defined below). User Content and/or User Derived Content may
                include, among other things, mistakes, typos, wording, and text
                contained in the content or information transmitted by you. To
                the maximum extent permitted by law, Emigo shall have no
                liability to you with respect to the User Content and or the
                User Derived Content, including, without limitation, liability
                with respect to: (i) any information (including your
                confidential information) contained in or apparent from any User
                Content and/or the User Derived Content; and/or (ii) any
                copyright infringement claim or another infringement claim by a
                third party in relation to or in connection with the User
                Content and/or the User Derived Content. You warrant, represent
                and covenant that: (i) you own or have a valid and enforceable
                license and all the necessary rights to use, submit or transmit
                all User Content and use the Service and the Software; (ii) that
                no User Content or User Derived Content (as defined below)
                infringes, misappropriates or violates or will infringe,
                misappropriate or violate, the rights (including, without
                limitation, any copyrights or other intellectual property
                rights) of any person or entity or any applicable law, rule or
                regulation of any government authority of competent
                jurisdiction; (iii) all summaries, content or text derived or
                extracted from the User Content using the Summarization Service
                and/or Software ("User Derived Content") shall be used by the
                User for personal use only; and (iv) the User shall not
                disseminate or distribute the User Content or User Derived
                Content in breach of any applicable law or third party's
                intellectual property rights or other rights. You acknowledge
                that the Services and the Software do not operate as an archive
                or file storage service. You are solely responsible for the
                backup of User Content and other safe guards appropriate for
                your needs. You retain all right, title, and interest in and to
                your User Content. To the maximum extent permitted by law, by
                uploading or entering any User Content, you give Emigo (and
                those it works with) a nonexclusive, worldwide, royalty-free and
                fully-paid, transferable and sub-licensable, perpetual, and
                irrevocable license to copy, store and use your User Content in
                order to (i) provide the Software and Services; (ii) administer
                and make improvements to the Software and Services (including,
                to improve the algorithms underlying the Software and the
                Services); and (iii) collect and analyze anonymous information.
                To the extent that User Content contains any third party data,
                you hereby warrant to have obtained all required consents from
                such third party to allow Emigo to use the User Content as set
                forth above.
              </p>
              <p className="leading-relaxed" data-id="element-546">
                <strong data-id="element-547">5.4 Feedback.</strong> If Emigo receives any feedback
                (e.g., questions, comments, suggestions or the like) regarding
                any of the Services and/or Software (collectively, "Feedback"),
                all rights, including Intellectual Property Rights in such
                Feedback shall belong exclusively to Emigo and that such shall
                be considered Emigo's Confidential Information. You hereby
                irrevocably, fully and unconditionally transfer and assign to
                Emigo all Intellectual Property Rights and remaining rights you
                have in such Feedback, without any further step or payment being
                necessary, and waive any and all moral rights you may have in
                respect thereto, and the right to assert or take legal action in
                connection with such rights. It is further understood that use
                of Feedback, if any, may be made by Emigo at its sole
                discretion, and that Emigo in no way shall be obliged to make
                use of any kind of the Feedback or part thereof.
              </p>
            </div>

            <div data-id="element-548">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-549">
                6. Privacy
              </h2>
              <p className="leading-relaxed" data-id="element-550">
                Our privacy policy is available on our website ("Privacy
                Policy").
              </p>
            </div>

            <div data-id="element-551">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-552">
                7. Third Party Components
              </h2>
              <p className="leading-relaxed" data-id="element-553">
                The Software may use or include third party open source
                software, files, libraries or components that may be distributed
                to you and are subject to third party open source license terms.
                If there is a conflict between any open source license and the
                terms of this Agreement, then the open source license terms
                shall prevail but solely in connection with the related third
                party open source software. To the maximum extent permitted by
                law, Emigo makes no warranty or indemnity hereunder with respect
                to any third party open source software.
              </p>
            </div>

            <div data-id="element-554">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-555">
                8. Disclaimers
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-556">
                <strong data-id="element-557">8.1</strong> To the maximum extent permitted by law, you
                acknowledge that the service, the Emigo content, and any other
                goods and/or services provided or made available by Emigo
                hereunder or related thereto (collectively, the "Emigo
                materials") are provided on an "As is" and "As available" basis,
                with all faults, and without any representation, warranty,
                guarantee, or condition of any kind whatsoever, whether express,
                implied or statutory, including without limitation any implied
                warranties or conditions of merchantability, satisfactory
                quality or arising from a course of dealing, law, usage, or
                regarding security, fitness for a particular purpose, quiet
                possession, non-infringement, title, quiet enjoyment,
                reliability, or that otherwise arise from a course of
                performance or dealing, or usage of trade, all of which are
                hereby disclaimed by Emigo, its suppliers, and licensors.
              </p>
              <p className="leading-relaxed mb-3" data-id="element-558">
                <strong data-id="element-559">8.2</strong> To the maximum extent permitted by law,
                Emigo and its licensors do not make any representation,
                warranty, guarantee or condition: (a) regarding the
                effectiveness, usefulness, reliability, timeliness,
                completeness, or quality of Emigo materials, the services or the
                software; (b) that your use of Emigo materials, the services or
                the software will be uninterrupted, secure or error-free; (c)
                regarding the operation of any networks, the passing or
                transmission of data via any networks or the cloud, or any other
                cellular or data connectivity problems; or (d) regarding the
                satisfaction of, or compliance with, any laws, regulations, or
                other government or industry rules or standards. We do not
                warrant that the content available on, or generated by, the
                software or the service is accurate, complete, reliable,
                current, error-free and/or that the service or the software is
                free of viruses or other harmful code. We reserve the right to
                make changes in or to the content, the software and/or the
                services, or any part thereof, without giving you any notice
                prior to or after making such changes. Emigo will not be liable
                or obligated in respect of delays, interruptions, service
                failures or other problems inherent in use of the internet and
                electronic communications or for issues related to public
                networks or hosting providers.
              </p>
              <p className="leading-relaxed mb-3" data-id="element-560">
                <strong data-id="element-561">8.3</strong> You are advised not to rely in any way on
                the correct functioning or performance of the extension. You
                assume all risks and all costs associated with the use of the
                software or service. You agree that we will not be held
                responsible for any consequences to you or any third party that
                may result from your use of the services and/or for any
                technical problems including without limitation in connection
                with the internet (such as slow connections, traffic congestion
                or overload of our or other servers) or any telecommunications
                or internet providers.
              </p>
              <p className="leading-relaxed" data-id="element-562">
                <strong data-id="element-563">8.4</strong> Applicable law may not allow the exclusion
                of certain warranties, so to that extent such exclusions may not
                apply.
              </p>
            </div>

            <div data-id="element-564">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-565">
                9. Limitation of Liability
              </h2>
              <p className="leading-relaxed" data-id="element-566">
                Notwithstanding anything to the contrary and to the fullest
                extent permissible by law, in no event shall either party, its
                affiliates, or any licensor or supplier of Emigo, be liable
                under, or otherwise in connection with, this agreement, for: (a)
                any consequential, indirect, special, incidental, or punitive
                damages; (b) any loss of profits, loss of business, loss of
                revenue, loss of anticipated savings, or wasted expenditure; (c)
                any loss of, or damage or interruption to, data, networks,
                information systems, reputation, or goodwill; and/or (d) the
                cost of procuring any substitute goods or services. To the
                maximum extent permitted by law, the combined aggregate
                liability of Emigo and its affiliates under, or otherwise in
                connection with, this agreement, the software and the service
                shall not exceed the amount actually paid (if any) by you to
                Emigo under this agreement in the three (3) month period
                immediately preceding the date giving rise to liability. The
                foregoing exclusions and limitation shall apply: (a) to the
                maximum extent permitted by applicable law; (b) even if a party
                has been advised, or should have been aware, of the possibility
                of losses, damages, or costs; (c) even if any remedy in this
                agreement fails of its essential purpose; and (d) regardless of
                the theory or basis of liability, and whether in contract, tort
                (including without limitation for negligence or breach of
                statutory duty), misrepresentation, restitution, or otherwise.
              </p>
            </div>

            <div data-id="element-567">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-568">
                10. Confidentiality
              </h2>
              <p className="leading-relaxed" data-id="element-569">
                You may have access to certain non-public or proprietary
                information and materials of Emigo and/or its Affiliates,
                whether in tangible or intangible form ("Confidential
                Information"). You shall take commercially reasonable measures
                to protect the Emigo's Confidential Information within your
                possession or control, from misuse or disclosure to a third
                party. You shall use the Emigo's Confidential Information solely
                for the purposes of performing under this Agreement. In the
                event that you are required to disclose Confidential Information
                of Emigo pursuant to any Law, regulation, or governmental or
                judicial order, you will (a) promptly notify Emigo in writing of
                such Law, regulation or order, (b) reasonably cooperate with
                Emigo in opposing such disclosure, (c) only disclose to the
                extent required by such Law, regulation or order (as the case
                may be).
              </p>
            </div>

            <div data-id="element-570">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-571">
                11. Indemnity
              </h2>
              <p className="leading-relaxed" data-id="element-572">
                To the maximum extent permitted by law, you agree to defend,
                indemnify and hold harmless Emigo and our affiliates, and our
                respective officers, directors, employees and agents, from and
                against any and all claims, damages, obligations, losses,
                liabilities, costs and expenses (including but not limited to
                attorney's fees) arising from: (i) your use of, or inability to
                use, the Software (ii) your violation of this Agreement; (iii)
                your violation of any third party right, including without
                limitation any copyright, property, or privacy right; and (iv) a
                third party claim relating to or in connection with the User
                Content and/or the User Derived Content (including but not
                limited to a claim for copyright infringement or related to
                intellectual property or proprietary rights). Without derogating
                from or excusing your obligations under this section, we reserve
                the right (at your own expense), but are not under any
                obligation, to assume the exclusive defense and control of any
                matter which is subject to an indemnification by you if you
                choose not to defend or settle it. You agree not to settle any
                matter subject to an indemnification by you without first
                obtaining our express approval.
              </p>
            </div>

            <div data-id="element-573">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-574">
                12. Export Laws
              </h2>
              <p className="leading-relaxed" data-id="element-575">
                You agree to comply fully with all applicable export laws and
                regulations to ensure that neither the Software and/or the
                Services nor any technical data related thereto are exported or
                re-exported directly or indirectly in violation of, or used for
                any purposes prohibited by, such laws and regulations.
              </p>
            </div>

            <div data-id="element-576">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-577">
                13. Updates and Upgrades
              </h2>
              <p className="leading-relaxed" data-id="element-578">
                We may from time to time and our discretion provide updates or
                upgrades to the Software and/or the Services (each a
                "Revision"), but are not under any obligation to do so. Such
                Revisions will be supplied according to our then-current
                policies, which may include automatic updating or upgrading
                without any additional notice to you. You consent to any such
                automatic updating or upgrading of the Software. All references
                herein to the Software shall include Revisions. This Agreement
                shall govern any Revisions that replace or supplement the
                original Software, unless the Revision is accompanied by a
                separate license agreement which will govern the Revision.
              </p>
            </div>

            <div data-id="element-579">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-580">
                14. Term and Termination
              </h2>
              <p className="leading-relaxed mb-3" data-id="element-581">
                <strong data-id="element-582">14.1</strong> This Agreement is effective until
                terminated by Emigo or you. We reserve the right, at any time,
                to: (i) discontinue or modify any aspect of the Software and/or
                the Services; and/or (ii) terminate this Agreement and your use
                of the Software and/or the Services, if you engage in any
                conduct or activities that we determine, in our sole discretion,
                violate this Agreement or the rights of Emigo or any third
                party, or is otherwise inappropriate, and, to the maximum extent
                permitted by law, Emigo shall not be liable to you or any third
                party for any of the foregoing. If you object to any term or
                condition of this Agreement or any subsequent modifications
                thereto, or become dissatisfied with the Software in any way,
                your only recourse is to immediately discontinue use of the
                Software. Unless otherwise stated in the Subscription Plan or
                required under applicable law, termination shall not give rise
                to any refund.
              </p>
              <p className="leading-relaxed" data-id="element-583">
                <strong data-id="element-584">14.2</strong> Upon termination of this Agreement, you
                shall cease all use of the Software. This Section 14 and
                Sections 9 to 13, 18 and 19 shall survive termination of this
                Agreement.
              </p>
            </div>

            <div data-id="element-585">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-586">
                15. Assignment
              </h2>
              <p className="leading-relaxed" data-id="element-587">
                This Agreement, and any rights and licenses granted hereunder,
                may not be transferred or assigned by you but may be assigned by
                Emigo without restriction or notification.
              </p>
            </div>

            <div data-id="element-588">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-589">
                16. Modification
              </h2>
              <p className="leading-relaxed" data-id="element-590">
                To the maximum extent permitted by law, Emigo reserves the right
                at any time to: (i) change any information, specifications,
                features or functions of the Services and/or Software, including
                any Trial Period, (ii) suspend or discontinue, temporarily or
                permanently, any or all of the Services or Trial Period,
                including the availability of any feature, database or content,
                or (iii) impose limits on certain features and Services or
                restrict access to parts or all of the Services, including any
                Trial Period, in each case with or without prior notice and
                without any liability to you or any third party. Emigo may from
                time to time update or revise this Agreement. If Emigo updates
                or revises this Agreement, Emigo will post the updated or
                revised Agreement on the website or by any other manner chosen
                by Emigo in its commercially reasonable discretion. Such change
                will be effective thirty (30) days following the foregoing
                notification thereof, and your continued use of the Software
                and/or Services thereafter means that you accept those changes
                to the Agreement as updated or revised. You can view the most
                current End User License Agreement on our website. It is your
                responsibility to review the Agreement periodically and we
                encourage you to do so.
              </p>
            </div>

            <div data-id="element-591">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-592">
                17. Governing Law and Disputes
              </h2>
              <p className="leading-relaxed" data-id="element-593">
                Notwithstanding anything to the contrary and to the fullest
                extent permissible by law, this Agreement shall be governed by
                and construed in accordance with the laws of the State of
                California without regard to its conflict of laws rules. You
                agree to submit to the personal and exclusive jurisdiction of
                the courts located in California, and waive any jurisdictional,
                venue, or inconvenient forum objections to such courts.
                Notwithstanding the foregoing, we may seek injunctive relief in
                any court worldwide of competent jurisdiction.
              </p>
            </div>

            <div data-id="element-594">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-595">
                18. General
              </h2>
              <p className="leading-relaxed" data-id="element-596">
                This Agreement, and any other legal notices published by us in
                connection with the Software, shall constitute the entire
                agreement between you and Emigo concerning the Software. In the
                event of a conflict between this Agreement and any of the
                foregoing, the terms of this Agreement shall prevail. If any
                provision of this Agreement is deemed invalid by a court of
                competent jurisdiction, the invalidity of such provision shall
                not affect the validity of the remaining provisions of this
                Agreement, which shall remain in full force and effect. No
                waiver of any term of this Agreement shall be deemed a further
                or continuing waiver of such term or any other term, and a
                party's failure to assert any right or provision under this
                Agreement shall not constitute a waiver of such right or
                provision.
              </p>
            </div>

            <div data-id="element-597">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-598">
                19. License Notices
              </h2>
              <p className="leading-relaxed mb-4" data-id="element-599">
                The Software may include third-party software components that
                are subject to separate license terms. Your use of such
                components is governed by the applicable third-party license
                agreements, which are incorporated herein by reference. Nothing
                in this Agreement is intended to limit or alter the terms of any
                applicable open source license. To the extent any open source
                license requires that we provide rights to use, copy, or modify
                a third-party component beyond the rights granted in this
                Agreement, those rights shall take precedence with respect to
                that component.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-600">
                The following third-party software components are included in
                the Emigo iOS application:
              </p>
              <p className="font-semibold mb-2" data-id="element-601">
                PostHog iOS (version 3.37.2) — MIT License
              </p>
              <p className="leading-relaxed mb-4" data-id="element-602">Copyright (c) 2023 PostHog</p>
              <p className="leading-relaxed mb-4" data-id="element-603">
                Permission is hereby granted, free of charge, to any person
                obtaining a copy of this software and associated documentation
                files (the "Software"), to deal in the Software without
                restriction, including without limitation the rights to use,
                copy, modify, merge, publish, distribute, sublicense, and/or
                sell copies of the Software, and to permit persons to whom the
                Software is furnished to do so, subject to the following
                conditions:
              </p>
              <p className="leading-relaxed mb-4" data-id="element-604">
                The above copyright notice and this permission notice shall be
                included in all copies or substantial portions of the Software.
              </p>
              <p className="leading-relaxed mb-4" data-id="element-605">
                THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
                EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
                OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
                HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES, OR OTHER LIABILITY,
                WHETHER IN AN ACTION OF CONTRACT, TORT, OR OTHERWISE, ARISING
                FROM, OUT OF, OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
                OTHER DEALINGS IN THE SOFTWARE.
              </p>
              <p className="font-semibold mb-2" data-id="element-606">
                Commercially Licensed Components
              </p>
              <p className="leading-relaxed mb-4" data-id="element-607">
                The Software also incorporates the following commercially
                licensed third-party components. These components are provided
                under applicable vendor license terms, are not open source, and
                are used in accordance with their respective commercial license
                agreements. No rights are granted to you under this Agreement
                with respect to such components beyond the right to use them as
                part of the Software in accordance with this Agreement.
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mb-4" data-id="element-608">
                <li data-id="element-609">KeyboardKit, version 10.3.0</li>
                <li data-id="element-610">LicenseKit, version 2.1.3</li>
              </ul>
              <p className="leading-relaxed" data-id="element-611">
                We may update the third-party components included in the
                Software from time to time. Updated license notices will be made
                available in this section and in our Privacy Notice. If you have
                questions about any third-party component or its license terms,
                please contact us at support@joinemigo.com.
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-200" data-id="element-612">
              <h2 className="text-2xl font-bold text-[#E87B5C] mb-4" data-id="element-613">
                Contact Information
              </h2>
              <p className="leading-relaxed" data-id="element-614">
                If you have any questions about these Terms of Service, please
                contact us at:
              </p>
              <p className="mt-4" data-id="element-615">
                <strong data-id="element-616">Email:</strong> support@joinemigo.com
              </p>
              <p className="mt-2" data-id="element-617">
                <strong data-id="element-618">Address:</strong> Attn: Support, Emigo Wellness, 131
                Continental Drive, Suite 305, United States
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}